import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { useServiceCenter } from '../../../../hooks/use-service-center';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { FlyoutTitle } from '../../../../components/flyout-components/FlyoutTitle';
import { StatusCode } from '../../../../utils/api';
import { ContainerRead } from '../../../../transportation/models/containers/container-read';
import { TransportationSvc } from '../../../../transportation/service';
import { ContainerEditBasicInfo } from '../../../../transportation/components/shipments/ContainerEditBasicInfo';

interface IProps {
    visible             : boolean;
    onSuccess           : any;
    onClose             : any;
    container           : ContainerRead;
}

export const ActionEditContainerInfo = (props: IProps) => {

    const userServiceCenter                 = useServiceCenter();    
    const [service]                         = React.useState(new TransportationSvc());
    const [editContainer, setEditContainer] = React.useState<ContainerRead>(new ContainerRead());
    const [isCreate, setIsCreate]           = React.useState(false);
  
    React.useEffect(() => {
        if (props.visible) {    

            const tmpContainer = {...props.container};
            if (props.container.id === 0 && props.container.serviceCenterId.length === 0) {
                tmpContainer.serviceCenterId = userServiceCenter.name === "ALL" ? '' : userServiceCenter.name;
                setIsCreate(true);
            }

            setEditContainer(tmpContainer);
        }
    }, [props.visible]);

    const handleOnChange = (newContainer : ContainerRead) => {
        if (newContainer) {
            setEditContainer({...newContainer});
        }
    };

    /**
     * Save the changes to the truck before closing
     */ 
    const onSaveInfo = async () => {

        if (editContainer) {
            
            const result = await service.saveRoute(editContainer);
            if (result.status === StatusCode.Success) {
                setEditContainer(undefined as unknown as ContainerRead);
                props.onSuccess(result.data);
            }
        }

    };

    /**
     * Cleanup some our state and close the panel
     */
    const onClose = () => {
        setEditContainer(undefined as unknown as ContainerRead);
        props.onClose();
    };

    return editContainer
            ? <Drawer 
                anchor="right" 
                onClose={ onClose }
                open={ props.visible }>
                <div className="stop-action-drawer mini stop-action-basic-info">

                    <FlyoutTitle 
                        onMobileClose={ onClose }
                        title="Edit Information" />

                    <ContainerEditBasicInfo
                        container={ editContainer }
                        showCompactUI={ true }
                        allowCarrierSet={ true }
                        onContainerChange={ handleOnChange } />

                    <FlyoutSaveCancel
                        onSave={ onSaveInfo }
                        onCancel={ onClose }
                    />

                </div>
        </Drawer>
        : null;
};
